<ng-container *ngIf="isHyperlink">
  <a href="#" (click)="onClick($event)" >{{text}}</a>
</ng-container>

<ng-container *ngIf="!isHyperlink">
  <span>{{text}}</span>
</ng-container>
